import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Title from './Title';
import moment from 'moment';

function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits() {
  return (
    <React.Fragment>
      <Title>Recent Repairs</Title>
      <Typography component="p" variant="h4">
        24
      </Typography>
      <Typography color="text.secondary" sx={{ flex: 1 }}>
        on {moment().format('D MMMM, YYYY')}
      </Typography>
      <div>
        <Link color="primary" href="#" onClick={preventDefault}>
          View repairs
        </Link>
      </div>
    </React.Fragment>
  );
}
